import { FC, useState } from 'react';
import {
    Button,
    Card,
    Modal,
    Title,
    Flex,
    Group,
    Tooltip,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconEye, IconPencil } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import Pedigree from '../pedigree/Pedigree';
import { SummaryTabMode } from '../summary-tab/SummaryTab';

// -----------------------------------------------------------------------------
export const FamilyHistory: FC = () => {
    const [modalShown, { close, toggle }] = useDisclosure(false);
    const [modalMode, setModalMode] = useState<SummaryTabMode>('view');
    const { t } = useTranslation(['patient-pages', 'common', 'encounters']);

    const handleViewClick = () => {
        setModalMode('view');
        toggle();
    };

    const handleEditClick = () => {
        setModalMode('edit');
        toggle();
    };

    // ---------------------------------------------------------------------------
    return (
        <>
            <Card shadow="sm" padding="sm" radius="md" withBorder>
                <Card.Section withBorder inheritPadding py="xs" mb="xs">
                    <Flex justify="space-between" align="center">
                        <Title order={4}>
                            {t('summaryPage.titles.familyPedigree', {
                                ns: 'patient-pages',
                            })}
                        </Title>
                        <Group gap="xs">
                            <Tooltip
                                label={t('buttons.view', {
                                    ns: 'common',
                                    defaultValue: 'View',
                                })}
                            >
                                <Button variant="subtle" size="xs" onClick={handleViewClick}>
                                    <IconEye size={14} />
                                </Button>
                            </Tooltip>
                            <Tooltip
                                label={t('buttons.edit', {
                                    ns: 'common',
                                    defaultValue: 'Edit',
                                })}
                            >
                                <Button variant="light" size="xs" onClick={handleEditClick}>
                                    <IconPencil size={14} />
                                </Button>
                            </Tooltip>
                        </Group>
                    </Flex>
                </Card.Section>

                <Pedigree
                    minimizedView={true}
                    mode={modalMode}
                />

            </Card>

            <Modal
                opened={modalShown}
                onClose={() => {
                    close();
                }}
                size="90vw"
                title={
                    <Title order={3}>
                        {t('summaryPage.titles.familyPedigree', {
                            ns: 'patient-pages',
                        })}
                    </Title>
                }
            >
                <Pedigree
                    minimizedView={false}
                    mode={modalMode}
                />
            </Modal>
        </>
    );
};

export default FamilyHistory;
